module.exports = __webpack_public_path__ + "static/media/events-poker.33846eda.jpg";